// ----------------------------------------------------------------------
import token from '../helpers/TokenDecoder'


export default {
  getAccountDetails
};

async function getAccountDetails() {

  const account = {
    displayName: token.getUserNameFromToken(),
    email: token.getRoleFromToken(),
    photoURL: '/static/mock-images/avatars/avatar_24.jpg'
  };

  return account;
}



